<!--
 * @Author: ZhaoDong
 * @Date: 2022-10-24 18:57:01
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-11-08 16:07:40
 * @Description: 使用限制
-->
<template>
  <a-form-model ref="ruleForm" labelAlign="right" :model="form" :rules="rules" :label-col="{ span: 4 }"
                :wrapper-col="{ span: 14 }">
    <!-- <h3 class="label_h3">使用限制</h3> -->
    <a-divider orientation="left">使用限制</a-divider>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="适用商品" prop="use_range_type">
          <a-radio-group v-model="form.use_range_type" @change="useRangeTypeChange">
            <div class="small-form-item">
              <a-radio value="1">全场通用</a-radio>
            </div>
            <div class="small-form-item">
              <a-radio value="2">仅指定业务线商品可用
                <a-form-model-item prop="business_ids" class="small-form-item-inline">
                  <a-select size="small" style="min-width: 240px" v-model="form.business_ids"
                            :disabled="form.use_range_type !== '2'" mode="multiple" :maxTagCount="1" placeholder="指定业务线">
                    <a-select-option v-for="item in projectChildList" :key="item.id" :value="item.id">
                      <a-tooltip placement="topLeft" :title="item.org" arrow-point-at-center>
                        {{ item.org }}
                      </a-tooltip>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-radio>
            </div>
            <div class="small-form-item">
              <a-radio value="3">仅指定订单可用
                <a-form-model-item prop="order_sn" class="small-form-item-inline">
                  <a-input-search v-model="order_keyword" size="small" :class="{
                                    'has-success': checkStatus == 1,
                                    'has-warning': checkStatus == 2,
                                    'has-error': checkStatus == 3
                                  }" :disabled="form.use_range_type !== '3'" placeholder="请输入订单编号"
                                  @search="handleValidOrder" :loading="loading">

                    <checkIcon :status="checkStatus" slot="suffix"></checkIcon>
                    <a-button slot="enterButton" :disabled="form.use_range_type !== '3'">
                      查询订单号是否存在
                    </a-button>
                  </a-input-search>
                </a-form-model-item>
              </a-radio>
            </div>
          </a-radio-group>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="使用平台" prop="platform">
          <a-select mode="multiple" placeholder="请选择使用平台" :default-value="defaultPlatform" v-model="form.platform">
            <a-select-option v-for="(value, key) in couponPlatOptions" :key="key" :value="key">
              {{ value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="互斥规则" prop="use_rule">
          <div class="flex-ac">
            <a-select placeholder="请选择互斥规则" :options="mutexRules" v-model="form.use_rule"> </a-select>
            <a-checkbox v-model="useMoreOrder" value="1" style="flex: 1 0 auto; margin-left:8px">不允许多订单共用</a-checkbox>
          </div>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { mapState } from 'vuex'
import { pick } from 'lodash'
import checkIcon from './checkIcon'
import api from '@/api'
function getChildProject(list, record, arr = []) {
  for (const iterator of list) {
    if (String(iterator.parent_id) === String(record.id)) {
      arr.push(iterator)
      getChildProject(list, iterator, arr)
    }
  }
  return arr
}
export default {
  props: {
    project: {
      type: [String, Number],
      default: () => ''
    },
    platformList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      form: {
        use_range_type: '1', // 使用商品 1全场通用 2金指定业务线可以 3仅指定订单可用
        use_rule: '1', // 互斥规则 1不可与其他优惠叠加使用
        use_is_more_order: '0', // 是否不允许多订单共用 0否 1是
        business_ids: [], // 指定业务线
        order_sn: [], // 指定订单
        platform: [] // 平台
      },
      rules: {
        use_range_type: [{ required: true, message: '请选择适用商品', trigger: ['change'] }],
        platform: [{ type: 'array', required: true, message: '请选择使用平台', trigger: ['change'] }],
        business_ids: [{ validator: this.validBusiness, trigger: ['change'] }],
        order_sn: [{ validator: this.validOrder, trigger: ['blur'] }],
        use_rule: [{ required: true, message: '请选择互斥规则', trigger: ['change'] }]
      },
      mutexRules: [{ label: '不可与其他优惠叠加使用', value: '1' }],
      checkStatus: 0, // 订单是否存在（输入框右侧的小图标 1： 成功状态， 2： 警告状态 3：错误状态）
      order_keyword: undefined // 订单号（搜索）
    }
  },
  computed: {
    ...mapState({ labels: state => state.label.data }),
    // 使用平台
    couponPlatOptions() {
      return this.labels?.COUPON_ENUM?.COUPON_PLAT
    },
    defaultPlatform() {
      return Object.keys(this.couponPlatOptions)
    },
    // antd的checkbox不支持true/false所对应的值
    useMoreOrder: {
      get() {
        return this.form.use_is_more_order === '1'
      },
      set(value) {
        this.form.use_is_more_order = value ? '1' : '0'
      }
    },
    lvProject() {
      return this.platformList && this.platformList.find(item => +item.project === +this.project)
    },
    projectChildList() {
      if (this.lvProject && this.platformList.length) {
        return getChildProject(this.platformList, this.lvProject)
      }
      return []
    }
  },
  created() { },
  mounted() {
    // 默认选中所有平台
    this.form.platform = Object.keys(this.couponPlatOptions).length ? Object.keys(this.couponPlatOptions) : []
  },
  methods: {
    useRangeTypeChange() {
      switch (this.form.use_range_type) {
        case '1':
          this.form.business_ids = []
          this.form.order_sn = []
          this.order_keyword = undefined
          this.checkStatus = 0
          break
        case '2':
          this.form.order_sn = []
          this.order_keyword = undefined
          this.checkStatus = 0
          break
        case '3':
          this.form.business_ids = []
          break
        default:
          break
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField(['order_sn', 'business_ids'])
      })
    },
    validBusiness(rule, value, callback) {
      if (
        this.form.use_range_type === '2' &&
        Array.isArray(this.form.business_ids) &&
        this.form.business_ids.length === 0
      ) {
        callback(new Error('请指定业务线'))
        return
      }
      callback()
    },
    handleValidOrder() {
      this.$refs.ruleForm.validateField(['order_sn'])
    },
    validOrder(rule, value, callback) {
      const keyword = this.order_keyword
      if (this.form.use_range_type === '3') {
        if (!keyword) {
          this.checkStatus = 2
          this.form.order_sn = []
          callback(new Error('请指定订单信息'))
          return
        } else {
          return this.onSearchOrder(keyword, this.project)
            .then(res => {
              callback()
            })
            .catch(() => {
              callback(new Error('未查询到该订单'))
            })
        }
      } else {
        callback()
      }
      callback()
    },
    /**
     * 查询订单是否存在
     */
    onSearchOrder(order_sn, project) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        try {
          const { data } = await api.CheckOrder({ order_sn, project })
          if (data) {
            this.checkStatus = 1
            this.form.order_sn = [order_sn]
            resolve()
          } else {
            this.checkStatus = 3
            this.form.order_sn = []
            reject(new Error(false))
          }
          this.loading = false
        } catch (error) {
          reject(new Error(error))
        }
      })
    },
    async validate() {
      const valid = await this.$refs['ruleForm'].validate()
      return valid
    },
    /**
     * 自定义校验空值
     * @return Promise<true|false>
     */
    validNotEmptyFields() {
      let validFields = []
      const { use_range_type } = this.form
      const _rulesKeys = Object.keys(this.rules)
      for (const key of _rulesKeys) {
        const filedValue = this.form[key]
          if (filedValue !== null && filedValue !== undefined && filedValue !== '') {
            validFields.push(key)
          }
      }

      if (use_range_type === '2') {
        validFields.push('business_ids')
      } else if (use_range_type === '3') {
        validFields.push('order_sn')
      }
      validFields = [...new Set(validFields)]
      let failCount = 0; let validCount = 0
      return new Promise((resolve, reject) => {
        this.$refs['ruleForm'].validateField(validFields, (err) => {
          ++validCount
          if (err) {
            failCount += 1
          }
          if (validCount === validFields.length) {
            failCount > 0 ? resolve(false) : resolve(true)
          }
        })
      })
    },
    async getValue(valid) {
      return new Promise((resolve, reject) => {
        if (valid) {
          this.$refs['ruleForm'].validate(valid => {
            if (valid) {
              resolve({ ...this.form })
            } else {
              reject(new Error('valid fail'))
            }
          })
        } else {
          resolve({ ...this.form })
        }
      })
    },
    setValue(data) {
      const _formData = pick.apply(undefined, [data].concat(Object.keys(this.form)))
      _formData.platform = data.usePlat.map(plat => plat.plat_id)
      _formData.business_ids = data.useBusiness.length ? data.useBusiness.map(b => b.line_id) : []
      this.form = _formData
      // 订单号处理
      if (Array.isArray(data.useOrders) && data.useOrders.length) {
        const order = data.useOrders[0]?.order_sn
        this.order_keyword = order
        this.form.order_sn = [order]
      }
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields()
    }
  },
  components: { checkIcon }
}
</script>

<style scoped lang="less">
.check-status {
  &.has-success {
    color: #52c41a;
  }

  &.has-error {
    color: #f5222d;
  }

  &.has-warning {
    color: #faad14;
  }
}

.check-status {
  &.status1 {
    color: #52c41a;
  }

  &.status2 {
    color: #faad14;

    /deep/ .ant-input {
      border-color: #faad14;

      &.ant-input:focus {
        border-color: #faad14;
      }
    }
  }

  &.status3 {
    color: #f5222d;

    /deep/ .ant-input {
      &.ant-input:focus {
        border-color: #ff4d4f;
      }

      border-color: #f5222d;
    }
  }
}
</style>
